module.exports = __webpack_public_path__ + "img/何建忠.e8774364.jpg";